module.exports = __webpack_public_path__ + "assets/img/06-l.034d605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/06-l.jpg
// module id = FCp/
// module chunks = 0